import React, { FunctionComponent } from 'react';

import { compose, composeU, ExtractProps } from '@bem-react/core';
import {
    Button as ButtonDesktop,
    withPinCircleCircle,
    withSizeXL,
    withViewClear,
    withViewLink,
} from '@ps-int/360-components/dist/components/Button/desktop';

import SvgImage from '../svg-image';
import { withSizeAuto } from './with-size-auto';

const LegoButton = compose(
    composeU(withViewClear, withViewLink),
    composeU(withSizeAuto, withSizeXL),
    withPinCircleCircle
)(ButtonDesktop);
type LegoButtonProps = ExtractProps<typeof LegoButton>;

export interface Props {
    onClose(): void;
    className?: string;
    type?: 'clear' | 'round';
    ariaLabel?: string;
}

const CloseButton: FunctionComponent<Props> = ({ onClose, className, type = 'clear', ariaLabel }) => {
    const buttonProps: LegoButtonProps =
        type === 'clear'
            ? {
                  view: 'clear',
                  size: 'auto',
                  icon: () => <SvgImage imageName="close" style={{ width: 24, height: 24 }} />,
              }
            : {
                  view: 'link',
                  size: 'xl',
                  icon: (className: string) => <SvgImage imageName="close" className={className} />,
                  pin: 'circle-circle',
              };
    return <LegoButton {...buttonProps} className={className} onClick={onClose} aria-label={ariaLabel} />;
};

export default CloseButton;
